import AudioPlayer from "../../../../components/AudioPlayer/AudioPlayer";
import LottieFromUrl from "../../../../components/LottieFromUrl/LottieFromUrl";
import { BreatheContent } from "../../../../hooks/useRetrieveBreatheExercise";
import "./RainbowContent.scss";

// Mirrors src/Utilities/formatTime.ts in mobile
function formatTime(time: number): string {
  const minutes = Math.floor(time / 60);
  const seconds = time % 60;
  return `${minutes}:${seconds < 10 ? `0${seconds}` : seconds}`;
}

interface RainbowContentProps {
  breatheContent: BreatheContent;
  isAudioPlaying?: boolean;
  timer: number;
  isLoopMusic?: boolean;
}

function RainbowContent({
  breatheContent,
  isAudioPlaying = true,
  timer,
  isLoopMusic = true,
}: RainbowContentProps) {
  const exercise = breatheContent.exercises[2];
  if (!exercise) return null;

  return (
    <div className="rainbow-content">
      <div className="rainbow-content__center">
        <LottieFromUrl
          url={exercise.images[0]?.url}
          className="rainbow-content__yeti"
        />
        <p className="rainbow-content__text">{exercise.title}</p>
        {exercise.audio && isAudioPlaying && (
          <AudioPlayer
            uri={exercise.audio}
            autoPlay
            loop={false}
            variant="compact"
            className="rainbow-content__audio"
          />
        )}
        {exercise.bgMusic && isAudioPlaying && (
          <AudioPlayer
            uri={exercise.bgMusic}
            autoPlay
            loop={isLoopMusic}
            variant="compact"
            className="rainbow-content__audio"
          />
        )}
      </div>
      {timer > 0 && (
        <span className="rainbow-content__timer">{formatTime(timer)}</span>
      )}
    </div>
  );
}

export default RainbowContent;
